import { useSnackbar, VariantType } from 'notistack';

let useSnackbarRef : any

interface ErrorProps {
    errorObj: {
        data: {
            errors: Record<string, string[]>;
        };
    };
}

const displayApiErrors = (errorObj: any, useSnackbarRef: any) => {
        if (errorObj && errorObj.data && errorObj.data.errors) {
            const { errors } = errorObj.data;
            Object.keys(errors).forEach(key => {
                errors[key].forEach((message: any) => {
                    useSnackbarRef.enqueueSnackbar(message, { variant: 'error' });
                });
            });
        }
    
};


export const SnackbarUtilsConfigurator  = () => {
  useSnackbarRef = useSnackbar()
  return null
}

export default {
  success(msg: string) {
    this.toast(msg, 'success')
  },
  warning(msg: string) {
    this.toast(msg, 'warning')
  },
  info(msg: string) {
    this.toast(msg, 'info')
  },
  apiError(err: any) {
    // Null-safe on err itself: a network error (no HTTP response) can call this with undefined, and
    // err.data would then throw a TypeError. Optional-chain err so an undefined/null arg falls through
    // to the generic fallback instead of crashing the caller.
    if(err?.data?.errors) {
    displayApiErrors(err, useSnackbarRef)
    } else if (err?.data?.message || err?.data?.detail) {
        // { code, message } bodies (e.g. 409 conflicts like DOMAIN_ALREADY_REGISTERED) carry a
        // user-facing message - surface it instead of the generic fallback. Select with || (not ??)
        // so a present-but-empty message falls through to detail rather than toasting a blank string.
        useSnackbarRef.enqueueSnackbar(err.data.message || err.data.detail, { variant: 'error', anchorOrigin: {
            vertical: 'top',
            horizontal: 'center',
        }, })
    } else if (typeof err === 'string' && err.trim() && !err.trim().startsWith('<')) {
        // A plain-text response body (e.g. the 429 "Verify rate-limited; retry in 60s.") arrives as a
        // bare string - the .data?.* branches above miss it, so it would hit the generic fallback and
        // show "Internal error" for what is really a rate-limit. Surface it verbatim. Skip HTML bodies
        // (a 5xx gateway error page) so we never toast a wall of markup.
        useSnackbarRef.enqueueSnackbar(err, { variant: 'error', anchorOrigin: {
            vertical: 'top',
            horizontal: 'center',
        }, })
    }else{
        useSnackbarRef.enqueueSnackbar('Internal error, please try again later', { variant: 'error',                 anchorOrigin: {
            vertical: 'top',
            horizontal: 'center',
        }, })
    }
  },
  error(msg: string) {
    this.toast(msg, 'error')
  },
  toast(msg: string, variant: VariantType = 'default') {
    useSnackbarRef.enqueueSnackbar(msg, { variant, anchorOrigin: {
        vertical: 'top',
        horizontal: 'center',
    }, })
  }
}